import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const STORAGE_KEY = "itsacademic_country_ack_timestamp";
const SHOW_DELAY_MS = 3000;
const SIX_MONTHS_MS = 180 * 24 * 60 * 60 * 1000;

export default function CountryAcknowledgementModal() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const lastAckStr = localStorage.getItem(STORAGE_KEY);
    const lastAck = lastAckStr ? parseInt(lastAckStr, 10) : 0;
    const now = Date.now();
    const shouldShow = !lastAck || now - lastAck > SIX_MONTHS_MS;

    if (shouldShow) {
      const timer = setTimeout(() => setOpen(true), SHOW_DELAY_MS);
      return () => clearTimeout(timer);
    }
  }, []);

  function handleAcknowledge() {
    localStorage.setItem(STORAGE_KEY, Date.now().toString());
    setOpen(false);
  }

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4 backdrop-blur-sm"
        >
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            transition={{ type: "spring", stiffness: 260, damping: 20 }}
            className="max-w-lg rounded-lg bg-white p-6 text-center shadow-xl"
          >
            <h2 className="mb-4 text-xl font-semibold text-gray-900">Acknowledgement of Country</h2>
            <p className="mb-6 text-sm text-gray-700">
              ItsAcademic was created on <strong>Gadigal and Wangal Country</strong>, part of the Eora Nation, by the team
              at <strong>Aperim Pty Ltd</strong>.
              <br />
              We pay our deepest respects to Elders past, present and emerging, and acknowledge the ongoing connection
              that First Nations peoples have to land, waters and culture.
            </p>
            <button
              onClick={handleAcknowledge}
              className="rounded-md bg-primary px-5 py-2 text-sm font-medium text-white shadow hover:bg-primary-dark"
            >
              I acknowledge
            </button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
